import {combineReducers} from 'redux';
import giphy from './giphy';

const reducers = combineReducers({
    giphy
});

export default reducers;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/